import React from 'react';
import ErrorMessage from './ErrorMessage';


// --- Start of src/components/FormInput.js ---
const FormInput = ({ label, type, name, value, onChange, error, placeholder = '' }) => (
  <div className="mb-4">
    <label htmlFor={name} className="block text-gray-700 text-sm font-bold mb-2">
      {label}:
    </label>
    <input
      type={type}
      id={name}
      name={name}
      value={value}
      onChange={onChange}
      className={`shadow appearance-none border rounded-lg w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
        error ? 'border-red-500' : 'focus:border-blue-500'
      }`}
      placeholder={placeholder}
    />
    {error && <p className="text-red-500 text-xs italic mt-1">{error}</p>}
  </div>
);
export default FormInput;
// --- End of src/components/FormInput.js ---
